import { SourceDataFindingType } from "@/api/dtos";

const mapping: Record<SourceDataFindingType, string> = {
    [SourceDataFindingType.Information]: 'Information',
    [SourceDataFindingType.ProtocolDeviation]: 'Protocol Deviation',
    [SourceDataFindingType.ImportantProtocolDeviation]: 'ImportantProtocol Deviation',
};

const sourceDataFindingTypeToText = (type?: SourceDataFindingType) => {
    if (!type) {
        return 'Unknown'
    }

    return mapping[type];
}

export default sourceDataFindingTypeToText;